export default[
    {
        path: '/',
        name: 'login', 
        component: () => import(/* webpackChunkName: "Login" */ './views/Login.vue')
    },
    {
        path: '/cadastrar',
        name: 'cadastrar', 
        component: () => import(/* webpackChunkName: "cadastrar" */ './views/cadastrar.vue')
    },

    {
        path: '/recuperaSenha',
        name: 'recuperaSenha', 
        component: () => import(/* webpackChunkName: "cadastrar" */ './views/recuperaSenha.vue')
    },

    {
        path: '/novaSenha',
        name: 'novaSenha', 
        component: () => import(/* webpackChunkName: "cadastrar" */ './views/novaSenha.vue')
    },
    {
        path: '/atualizar/dados/pessoais',
        name: 'Atualizar dados pessoais', 
        component: () => import(/* webpackChunkName: "cadastrar" */ './views/dadospessoais.vue')
    },
    {
        path: '*',
        name: 'error', 
        component: () => import(/* webpackChunkName: "cadastrar" */ './views/erro.vue')
    },
]